<template>
    <v-app ref="app">
            <TestModule v-if="currentModule ==='TestModule'" ref="TestModule"/>
            <HelpModule v-if="currentModule ==='HelpModule'" ref="HelpModule"/>
            <QBModule v-if="currentModule ==='QBModule'" ref="QBModule"/>
            <EMModule v-if="currentModule ==='EMModule'" ref="EMModule"/>
            <FormModule v-if="currentModule ==='FormModule'" ref="FormModule"/>
            <DashboardModule v-if="currentModule ==='DashboardModule' || currentModule === 'ReleaseViewerDialog'" ref="DashboardModule"/>
            <SurveyStatsModule v-if="currentModule ==='SurveyStatsModule'" ref="SurveyStatsModule"/>
            <ReportTypeModule v-if="currentModule ==='ReportTypeModule'" ref="ReportTypeModule"/>
            <AssessmentStatsModule v-if="currentModule ==='AssessmentStatsModule' || currentModule === 'ParticipantsDialog'" ref="AssessmentStatsModule"/>
            <KioskModule v-if="currentModule ==='KioskModule'" ref="KioskModule"/>
            <SupersetModule v-if="currentModule ==='SupersetModule'" ref="SupersetModule"/>
            <CustomersModule v-if="currentModule === 'CustomersModule'" ref="CustomersModule"/> 
            <AISearchModule v-if="currentModule === 'AISearchModule'" ref="AISearchModule"/> 
            <ProjectCalendarModule v-if="currentModule === 'ProjectCalendarModule' || currentModule === 'ProjectCalendarAssistantDialog'" ref="ProjectCalendarModule"/>
						<DialogManager ref="DialogManager" v-on:refresh="refreshModule"/> 
            <PayrollPreviewModule v-if="currentModule === 'PayrollPreviewModule'" ref="PayrollPreviewModule"/>
            <AddCalendarHolidaysDialog v-if="currentModule === 'AddCalendarHolidaysDialog'" ref="AddCalendarHolidaysDialog"/>
            <ComplaintConfigModule v-if="currentModule === 'ComplaintConfigModule'" ref="ComplaintConfigModule"/>
            <ExpenseSheetDetailDialog v-if="currentModule === 'ExpenseSheetDetailDialog'" ref="ExpenseSheetDetailDialog"/>
            <UpgradeLicenseDialog v-if="currentModule === 'UpgradeLicenseDialog'" ref="UpgradeLicenseDialog"/>
            <PurchaseLicenseItemDialog v-if="currentModule === 'PurchaseLicenseItemDialog'" ref="PurchaseLicenseItemDialog"/>
            <ProjectCalendarAssistantDialog v-if="currentModule === 'ProjectCalendarAssistantDialog' || currentModule === 'ProjectCalendarModule'" ref="ProjectCalendarAssistantDialog"/>
            <ManageCalendarRulesDialog v-if="currentModule === 'ManageCalendarRulesDialog'" ref="ManageCalendarRulesDialog"/>
            <ParticipantsDialog v-if="currentModule === 'ParticipantsDialog' || currentModule === 'AssessmentStatsModule'" ref="ParticipantsDialog"/>
            <ReleaseViewerDialog v-if="currentModule === 'ReleaseViewerDialog' || currentModule === 'DashboardModule'" ref="ReleaseViewerDialog"/>
            <AiAssistantDialog ref="AiAssistantDialog"/>
            <VacationAssistantDialog ref="VacationAssistantDialog"/>
    </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import TestModule from './components/modules/TestModule'
import HelpModule from './components/modules/HelpModule'
import QBModule from './components/modules/QBModule'
import EMModule from './components/modules/EMModule'
import DashboardModule from './components/modules/DashboardModule'
import FormModule from './components/modules/FormModule'
import SurveyStatsModule from './components/modules/SurveyStatsModule'
import ReportTypeModule from './components/modules/ReportTypeModule'
import AssessmentStatsModule from './components/modules/AssessmentStatsModule'
import KioskModule from './components/modules/KioskModule'
import SupersetModule from './components/modules/SupersetModule'
import CustomersModule from './components/modules/CustomersModule'
import DialogManager from './components/modules/DialogManager'
import AISearchModule from './components/modules/AISearchModule'
import ProjectCalendarModule from './components/modules/ProjectCalendarModule'
import PayrollPreviewModule from './components/modules/PayrollPreviewModule'
import AddCalendarHolidaysDialog from './components/modules/dialogs/AddCalendarHolidaysDialog'
import ComplaintConfigModule from './components/modules/ComplaintConfigModule'
import ExpenseSheetDetailDialog from './components/modules/dialogs/ExpenseSheetDetailDialog'
import UpgradeLicenseDialog from './components/modules/dialogs/license/UpgradeLicenseDialog'
import PurchaseLicenseItemDialog from './components/modules/dialogs/license/PurchaseLicenseItemDialog'
import ProjectCalendarAssistantDialog from './components/modules/dialogs/ProjectCalendarAssistantDialog'
import ManageCalendarRulesDialog from './components/modules/dialogs/ManageCalendarRulesDialog'
import ParticipantsDialog from './components/modules/dialogs/ParticipantsDialog'
import ReleaseViewerDialog from './components/modules/dialogs/ReleaseViewerDialog'
import AiAssistantDialog from './components/modules/dialogs/AiAssistantDialog'
import VacationAssistantDialog from './components/modules/dialogs/VacationAssistantDialog'
import moment from 'moment';
import { EventBus }  from './components/util/event-bus'
import gwt from './api/gwt'
import { createWebSocketService } from './services/websocket'

export default {
  name: 'App',
  components: {
    DialogManager, TestModule, HelpModule, QBModule, ReportTypeModule,FormModule, SurveyStatsModule,AssessmentStatsModule, 
		KioskModule, CustomersModule, EMModule, DashboardModule, AISearchModule, ProjectCalendarModule, PayrollPreviewModule,
		AddCalendarHolidaysDialog, SupersetModule, ComplaintConfigModule, ExpenseSheetDetailDialog, UpgradeLicenseDialog,
    PurchaseLicenseItemDialog, ProjectCalendarAssistantDialog, ManageCalendarRulesDialog, ParticipantsDialog, AiAssistantDialog, ReleaseViewerDialog,
    VacationAssistantDialog
  },

  data () {
      return { 
          currentModule: null,
          websocketService: null,
          gwtBridgeWaitTimer: null
      }
    },
  mounted: function ()  {
      let me = this;
      this.websocketService = createWebSocketService(
        () => gwt.getSessionInformation(),
        () => me.refreshModule()
      );
      this.$nextTick(() => {
            window.$vueBridge = me;
            me.$refs.app.$el.firstChild.style.minHeight="100%";
    });
      
    EventBus.$on('widget-data-click',payload => {
        if (payload.mode==='VUEDIALOG') {
          me.$refs.DialogManager.processEvent( payload.mode, payload.type,payload.action,payload.payload, payload.eventConfig);
        } else {
          gwt.processEvent( payload.mode, payload.type,payload.action,payload.payload);
        }
      });

      this.connectWebSocketWhenReady();
  },
  beforeDestroy() {
    if (this.gwtBridgeWaitTimer !== null) {
      window.clearTimeout(this.gwtBridgeWaitTimer);
      this.gwtBridgeWaitTimer = null;
    }
    if (this.websocketService) {
      this.websocketService.disconnect();
    }
  },
  methods: {
    connectWebSocketWhenReady(attempt = 0) {
      const sessionInformation = gwt.getSessionInformation();
      const username = sessionInformation && sessionInformation.employee
        ? sessionInformation.employee.username
        : null;

      if (username) {
        this.websocketService.connect(username);
        return;
      }

      if (attempt >= 100) {
        console.warn("GWT bridge was not ready in time for websocket initialization");
        return;
      }

      this.gwtBridgeWaitTimer = window.setTimeout(() => {
        this.connectWebSocketWhenReady(attempt + 1);
      }, 100);
    },
    applyLocale(locale)
    {
      this.$i18n.locale = locale ? locale.substring(0, 2) : 'en';

      moment.locale(locale);
    },
    getCurrentModule() {
        return this.currentModule;
    },
    refreshModule() {
      if (this.currentModule && this.$refs[this.currentModule] && this.$refs[this.currentModule].refreshModule) {
        this.$refs[this.currentModule].refreshModule();
      }
    },
    showModule(module,payload) {
        let me = this;
        if (['VacationAssistantDialog', 'AiAssistantDialog', 'ReleaseViewerDialog', 'ProjectCalendarAssistantDialog'].includes(module) == false) {
            me.currentModule = module;
        }
        this.$nextTick(() => {
						if (me.$refs[module] && me.$refs[module].onReveal) {
								me.$refs[module].onReveal(payload);
						}
        });

    },
    hideModule(module) {
        let me = this;
        this.$nextTick(() => {
						if (me.$refs[module] && me.$refs[module].close) {
								me.$refs[module].close();
						}
        });
    }
  }
}
</script>
